var map = {
	"./cs.json": 209,
	"./da.json": 210,
	"./de.json": 211,
	"./en.json": 212,
	"./es.json": 213,
	"./fil.json": 214,
	"./fr.json": 215,
	"./hu.json": 216,
	"./it.json": 217,
	"./ms.json": 218,
	"./nl.json": 219,
	"./pl.json": 220,
	"./pt_BR.json": 221,
	"./pt_PT.json": 222,
	"./ro.json": 223,
	"./ru.json": 224,
	"./sk.json": 225,
	"./sv.json": 226,
	"./th.json": 227,
	"./tr.json": 228
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;


//////////////////
// WEBPACK FOOTER
// ./src/i18n ^\.\/.*\.json$
// module id = 208
// module chunks = 3